import script from "./Address.step.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.step.vue?vue&type=script&setup=true&lang=js"

import "./Address.step.vue?vue&type=style&index=0&id=01083ec8&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QFooter,QBtn});
